import React from 'react';
import {goRoute} from '../common/js'
import InfiniteScroll from "react-infinite-scroller";
import util from "../../util/tools";
import Header from "../common/Header";
import './index.css';

export default class Index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isShowResult: false,
            hotData: [],
            searchData: [],
            searchHistoryData:[],
            historyData:[],
            loading: "no", //默认不显示 true：加载中 false：已到底部
            curPage: 1,//
            value: '',
            value1: '',
            searchVal: ""
        };
        this.result = this.result.bind(this);
    }
    
    componentDidMount() {
        document.title = '搜索'
        this.getHotData()
        this.defaultKeyWord()

        this.setState({
            historyData : JSON.parse(localStorage.getItem('_sh_array') || '[]')
        })
    }
    // 热搜词
    getHotData() {
        util.ajax({
            url: "/zh/hotword/lists",
            isUser: true,
            isWechatId: true,
            data: {
                num: 12
            },
            callback: res => {
                if (res.result.status.code == 0) {
                    let data = res.result.data
                    this.setState({
                        hotData: data
                    })
                }
            }
        });
    }
    // 默认搜索值
    defaultKeyWord(){
        util.ajax({
            url: "/zh/book/ranking",
            isUser: true,
            isWechatId: true,
            data: {
                re_cid:143,
            },
            callback: res => {
                if (res.result.status.code == 0) {
                    let data = res.result.data
                    if(data.length>0){
                        let df = data[0].book_title
                        this.setState({
                            value1:df
                        })
                    }
                }
            }
        });
    }
    // 清空搜索
    clearData() {
        this.input.value = "";
        this.setState({
            value: '',
            searchData:[],
            isShowResult:false
        })
    }
    // 删除搜索历史
    clearAll(){
        this.setState({
            historyData: []
        })
        localStorage.removeItem('_sh_array')
    }

    func(e){
        let id = 'search_btn';
        if(!!e){
            id = e.target.getAttribute('data-id')
        }
        if(id == "search_input"){
            if(e.keyCode != 13){
                return false;
            }
        }
        let value = "";
        try{
            value = this.input.value;
        }catch(ee){}
        if(value == ""){
            this.input.value = this.state.value1
            value = this.state.value1;
        }
        if(!value){
            return false;
        }
        if((!!e && e.keyCode==13) || id=='search_btn'){
            !!e && e.preventDefault();
            let ArrayObj = JSON.parse(localStorage.getItem('_sh_array') || '[]')
            let newObj = {}
            newObj.word = value
            let tempArr = ArrayObj.filter(((item, index) => {
                return item.word != newObj.word
            }))
            if(tempArr.length == ArrayObj.length){
                // 搜索词不在记录中
                ArrayObj.unshift(newObj);
            }
            localStorage.setItem('_sh_array',JSON.stringify(ArrayObj))

            this.setState({
                value: value,
                loading: "no",
                searchVal: value,
                curPage: 1
            },()=>{
                this.result()
            });
        }
        return false;
    }

    result(){
        let value = this.state.searchVal;
        if (this.state.loading != "no") {
            return false;
        }
        this.setState({
            loading: true
        },()=>{
            let curPage = this.state.curPage || 1;
            let pageNum = 10;
            util.ajax({
                url: "/zh/book/searchBookv1",
                isUser: true,
                isWechatId: true,
                data: {
                    'num': pageNum,
                    'page': curPage,
                    'title_or_name': `%%${value}`,
                },
                callback: res => {
                    if (res.result.status.code == 0) {
                        let data = res.result.data;
                        let searchData = [];
                        if (data.length > 0) {
                            searchData = data;
                        }
                        if(curPage != 1){
                            searchData = this.state.searchData.concat(searchData);
                        }
                        let tempObj = {
                            searchData: searchData,
                            isShowResult: true,
                            loading: "no",
                            curPage: curPage + 1
                        };
                        if(!!localStorage.getItem('_sh_array')){
                            tempObj.historyData = JSON.parse(localStorage.getItem('_sh_array'));
                        }
                        if (data.length < pageNum) {
                            // 最后一页
                            tempObj.loading = false;
                        }
                        this.setState(tempObj)
                    }
                }
            });
        });
    }
    // 关键词搜索
    keyWord(item){
        this.input.value = item.word;
        this.setState({
            value:item.word,
            loading: "no",
            searchVal: item.word,
            curPage: 1
        },()=>{
            if(!!item.word_id){
                util.ajax({
                    url: "/zh/hotword/updateClickNum",
                    isUser: true,
                    data: {
                        'word_id': `${item.word_id}`
                    },
                    callback: res => {
                        if (res.result.status.code == 0) {
                        }
                    }
                })
            }
            this.func()
        })
    }

    render() {
        return (
            <div className='search_container'>
                <Header />
                <div className='search'>
                    <form data-id="search_btn" onSubmit={(e)=>this.func(e)} action="">
                        <input placeholder={this.state.value1} ref={ref => this.input = ref} autoComplete='off' className='search_inp' type="search"/>
                        <div className='search_btn' data-id="search_btn" onClick={(e) =>this.func(e)}>搜索</div>
                        <img className='search_icon1' src={require('../../../common/images/search.png')} alt=""/>
                        <div className='search_clear' onClick={()=>this.clearData()}></div>
                    </form>
                </div>
                <div className='line'></div>
                {!this.state.isShowResult &&
                    // 热搜和历史
                    <div>
                        <div className='module'>
                            <span className='module_title'>热搜</span>
                            <div className='module_items'>
                                {
                                    this.state.hotData.length > 0 &&
                                        this.state.hotData.map((item, index) => {
                                            if(!!item.word){
                                                return (
                                                    <a className='module_items_single' key={`hot${index}`} onClick={()=>this.keyWord(item)}>{item.word}</a>
                                                )
                                            }
                                        })
                                }
                            </div>
                        </div>
                        <div className='line'></div>
                        <div className='module'>
                            <span className='module_title'>历史</span>
                            {!!this.state.historyData && this.state.historyData.length>0 &&
                            <div className='module_items noMaxH'>
                                {
                                    this.state.historyData.map((item, index) => (
                                        <div className='module_items_single' key={`sh${index}`} onClick={()=>this.keyWord(item)}>{item.word}</div>
                                    ))
                                }
                            </div>
                            }
                            <img className='module_del' src={require('../../../common/images/rubbish.png')} onClick={()=>this.clearAll()}/>
                        </div>
                    </div>
                }

                {/* 搜索结果 */}
                <div className={`result ${!this.state.isShowResult?"nodis":""}`}>
                    <p className='result_title'>搜索结果</p>
                    <div className='result_items'>
                    <InfiniteScroll
                        initialLoad={false}
                        pageStart={0}
                        loadMore={this.result}
                        hasMore={true}
                    >
                        {
                            !!this.state.searchData && this.state.searchData.length > 0
                                ?
                                this.state.searchData.map((item, index) => (
                                    <div className='result_items_single' key={`list${index}`} onClick={()=>goRoute(this.props,item.book_id,0)}>
                                        <span className='result_items_single_title'>
                                            {item.book_title}
                                        </span>
                                        <div className='result_items_single_intro'>
                                            {item.book_intro}
                                        </div>
                                        <div className='result_items_single_bot'>
                                            <span className='result_items_single_bot_l'>{item.author_name}</span>
                                            <div className='result_items_single_bot_r'>
                                                {!!item.word_count && <span className='result_items_single_bot_r_single'>{((parseInt(item.word_count))/10000).toFixed(2)}万字</span>}
                                                {!!item.writing_process && <span className='result_items_single_bot_r_single'>{parseInt(item.writing_process) ==1?'完本':'连载'}</span>}
                                                {!!item.category_info.category_1.short_name && <span className='result_items_single_bot_r_single'>{item.category_info.category_1.short_name}</span>}
                                            </div>
                                        </div>
                                    </div>
                                )) :
                                <div className='result_no'>
                                    <img className='result_no_pic' src={require('../../../common/images/no.png')} alt=""/>
                                    <span className='result_no_font'>没有找到相关内容，换个关键字试试</span>
                                </div>
                        }
                    </InfiniteScroll>
                    </div>
                    {/*无结果*/}
                </div>

                <div id="containerId" className="containerId"></div>
            </div>
        );
    }
}